import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { FeatureDecimalFormat, RangeFeature } from "src/app/model/catalog/catalog.model";
import { GlobalStorageService } from "src/app/service-utils/global-storage.service";
import { i18nService } from "src/app/service-utils/i18n.service";
import { CatalogService } from "src/app/utils/catalog.service";

@Component({
    selector: 'app-response-view',
    templateUrl: './response-view.component.html',
    styleUrls: ['./response-view.component.scss']
    })
export class ResponseViewComponent implements OnChanges {

    @Input() data$: Observable<Object>;
    @Input() title: string;
    @Input() decimalFormats: Array<FeatureDecimalFormat>;

    lensBackSide: string;
    additionInfo: string;

    data: any;
    originalFeatures: Array<RangeFeature>;
    features: Array<RangeFeature> = [];

    selectedAdditionalOption: any;
    selectedPrismType: string;

    optional: any;
    additionalOptions: Array<any> = [];
    childrenAdditionalOption: Array<any> = [];
    childrenAdditionalOptionValues: Array<any> = [];

    childrenPrismType: Array<any> = [];

    form: FormGroup;
    formResponse: FormGroup;

    isSoftCL = false;

    counterDefaultInitValues = 0;
    initiatedFields = [];

    prismFormControl = "Prism";
    directionFlatMeridianFormControl = "DirectionFlatMeridian";

    originalFeaturesInit: Array<RangeFeature> =
        [SPHERE, RADIUS_BASE_CURVE, CYLINDER, AXIS_CYLINDER, DIAMETER, RADIUS_BASE_CURVE_2, ECCENTRICITY, DIOPTRE_STEEP,
        BACK_OPTIC_DIAMETER, FLATTENING_PROFILE];

    constructor(
        private formBuilder: FormBuilder,
        //private proposalResponseViewService: ProposalResponseViewService,
        private catalog: CatalogService,
        public i18n: i18nService,
        private globalStorageService: GlobalStorageService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if(this.data$) {
            this.data$.subscribe(data => {
                this.data = data;
                if(this.data) {
                    console.log(data);
                    this.lensBackSide = this.data.ID;
                    this.additionInfo = this.data.Info;

                    this.initFeatures();
                    this.initFormGroup();
                    this.initAdditionalOptions();
                    this.initMainOptions();
                }
            });
        }
    }

    private initAdditionalOptions() {
        this.selectedAdditionalOption = undefined;
        this.addAdditionalOptions(this.data.Optional[0]);
    }

    private initMainOptions() {
        Object.keys(this.form.controls).forEach(key => {
            if(this.data[key] !== undefined) {
                this.form.get(key).setValue(this.data[key].toString().replace(/\./g, ','));
            }
        })
    }

    public getPrismaPrismType() {
        let values = [];
        if(this.data.Optional.Prisma) {
            if(this.data.Optional.Prisma.Classic) {
                values.push(this.data.Optional.Prisma.Classic.prismType.value);
            }
            if(this.data.Optional.Prisma.Lenticular) {
                values.push(this.data.Optional.Prisma.Lenticular.prismType.value);
            }
        }
        return values;
    }

    getHintTranslation(feature: RangeFeature): Observable<string> {
        return this.catalog.getFeatureHintTranslation(feature.name);
    }

    getHintTranslationResponseParameters(child: any): Observable<string> {
        return this.catalog.getFeatureHintTranslation(this.getKey(child));
    }

    private initFeatures(isNeedCalcFeature = false, child? :any) {
        this.originalFeatures = this.originalFeaturesInit;
        let dataInput = (isNeedCalcFeature) ? child : this.data;
        if(isNeedCalcFeature) {
            if(dataInput.NameNew) {
                this.changeLensBackSide(dataInput.NameNew);
            } else {
                this.changeLensBackSide(this.data.ID);
            }
        }

        Object.keys(dataInput).forEach(key => {
            let index = this.originalFeatures.findIndex(feature => feature.name === key);
            if( index >= 0) {
                this.features.push(this.originalFeatures[index]);
            }
        });
    }

    changeLensBackSide(newLensBackSide: string) {
        this.lensBackSide = newLensBackSide;
    }

    private initFormGroup() {
        this.formBuilder.group({});
        this.formResponse = this.formBuilder.group({});
        this.form = this.formBuilder.group(this.createFormConfig(this.features));
    }

    private reInitFormResponse(isPrisma: boolean, children?: any) {
        this.formResponse = this.formBuilder.group(this.createFormResponseConfig(isPrisma, children));
    }

    private createFormConfig(originalFeatures: Array<any>) {
        let config = {};
        originalFeatures.forEach(feature => {
          config[feature.name] = [""];
        })
        return config;
    }

    private createFormResponseConfig(isPrisma, children: any) {
        let config = {};
        if(isPrisma) {
            config["PrismType"] = [""];
            config["Prism"] = [""];
        } else {
            children.forEach(feature => {
                config[this.getFormControlName(feature)] = [""];
            })
        }

        return config;
    }

    getTranslation(feature: RangeFeature): Observable<string> {
        return this.catalog.getFeatureTranslation(feature.name);
    }

    private addAdditionalOptions(typeLenses: any) {
        this.additionalOptions = [];
        this.optional = typeLenses;
        const defaultValue: string = this.optional['Defaultvalue'] ? this.optional['Defaultvalue'] : '';
        console.log('DefaultValue: ', defaultValue);
        Object.keys(this.optional).forEach(key => {
            let value = this.optional[key];
            if(typeof value === 'object' && value !== null) {
                this.additionalOptions.push({[key]: value[0]});
            }
        });
        let none = {"None": undefined};
        this.additionalOptions.push(none);
        if (defaultValue.length > 0) {
          this.additionalOptions.forEach((key, value) => {
            if (Object.keys(key)[0] == defaultValue) {
              this.selectedAdditionalOption = this.additionalOptions[value];
            }
          });
          this.calculateChildren();
        }
    }

    getKey(option: any): string {
        return Object.keys(option)[0];
    }

    getFormControlName(option: any): string {
        return (this.getKey(option) === this.directionFlatMeridianFormControl) ? this.directionFlatMeridianFormControl : option[Object.keys(option)[0]].templateID;
    }

    // TODO: refactor all, overcomplicated entities
    calculateChildren(event?: any) {
        this.initiatedFields = [];
        this.selectedPrismType = "";
        let children = [];
        let childrenAll = [];
        let selected = this.getKey(this.selectedAdditionalOption);
        let content = this.selectedAdditionalOption[selected];

        if(this.isSoftCL && selected === 'None') {
            this.features = [];
            this.initFormGroup();
        }

        if((this.features.length === 0 || this.isSoftCL) && selected !== 'None') {
            this.features = [];
            this.isSoftCL = true;
            this.initFeatures(true, content);
            this.initFormGroup();
            this.initMainOptions();
        } else if(selected !== 'Prisma' && selected !== 'None'){
            const a: Array<any> = Object.values(this.selectedAdditionalOption);
            if (a[0].NameNew != undefined) {
              this.changeLensBackSide(a[0].NameNew);
            } else {
              this.changeLensBackSide(this.data.ID + " " + selected);
            }
        } else {
            this.changeLensBackSide(this.data.ID);
        }

        if(selected === 'Prisma') {
            let childPrismType = [];
            Object.keys(this.selectedAdditionalOption[selected]).forEach(keyPrisma => {
                let value = this.selectedAdditionalOption[selected][keyPrisma];
                if(typeof value === 'object') {
                    childPrismType.push(value[0].PrismType[0].Value.toLowerCase());
                    children.push({[keyPrisma]: value[0]});
                } else {
                    childrenAll.push({[keyPrisma]: value});
                }
            })
            this.childrenPrismType = childPrismType;
            this.reInitFormResponse(true);
        } else if(selected !== 'None') {
            Object.keys(content).forEach(key => {
                let value = content[key];
                if(typeof value === 'object') {
                    children.push({[key]: value[0]});
                } else if(key === this.directionFlatMeridianFormControl) {
                    children.push({[key]: (parseInt(value) === 0) ? {"Defaultvalue": 0, "value": 90, "templateID": this.directionFlatMeridianFormControl}
                        : {"Defaultvalue": 90, "value": 0, "templateID": this.directionFlatMeridianFormControl}});
                }else {
                    childrenAll.push({[key]: value});
                }
            });
            this.reInitFormResponse(false, children);
        }
        this.childrenAdditionalOption = children;
        childrenAll.forEach(feature => {
            const key = this.getKey(feature);
            const value = Object.values(feature)[0];
            const index = this.features.findIndex(feature => feature.name === key);
            if(index >= 0) {
                this.form.get(this.features[index].name).setValue((value + '').replace('.',','));
            }
        });
    }

    getChildrenAdditionalOptionValues(option: any) {
        let childrenValues = [];
        let keyOption = this.getKey(option);
        Object.keys(option[keyOption]).forEach(key => {
            if(key.toLowerCase().includes('value')) {
                let value = option[keyOption][key];
                if(this.getKey(option) === "PrismType") {
                    value = value.toLowerCase();
                }
                if(!childrenValues.includes(value)) {
                    childrenValues.push(value);
                }
            }
        })
        return childrenValues;
    }

    isNumber(option: any): boolean {
        if(this.getKey(option) === this.directionFlatMeridianFormControl) {
            return false;
        }
        if(Object.keys(option[this.getKey(option)]).findIndex(key => key.toLowerCase().includes("value")) > -1){
            return typeof this.selectedAdditionalOption[this.getKey(this.selectedAdditionalOption)][this.getKey(option)][0].Defaultvalue === 'number';
        }
        return true;
    }

    getDefaultValueNumber(option: any): any {
        let key = this.getKey(option);
        let defaultValue = (option[key].Defaultvalue === undefined) ? "" : option[key].Defaultvalue;
        if(!this.initiatedFields.includes(key)) {
            this.formResponse.get(this.getFormControlName(option)).setValue(defaultValue);
            this.initiatedFields.push(key);
            this.setValueWithFormat(key);
        }
        return this.i18n.replaceFromDotToComma(defaultValue);
    }

    getDefaultValueSelect(option: any) {
        let key = this.getKey(option);
        if(!this.initiatedFields.includes(key)) {
            let defaultValue = option[key].Defaultvalue;
            this.formResponse.get(this.getFormControlName(option)).setValue(defaultValue);
            this.initiatedFields.push(key);
        }
    }

    getPrismDefaultValue(): any {
        let keyChildPrism: string;
        this.selectedPrismType === 'classic' ? keyChildPrism = 'Classic' : keyChildPrism = this.selectedPrismType;
        let defaultValue = this.selectedAdditionalOption[this.getKey(this.selectedAdditionalOption)][keyChildPrism][0].Prism[0].Defaultvalue;
        if(!this.initiatedFields.includes(this.prismFormControl)) {
            this.initiatedFields.push(this.prismFormControl);
            this.formResponse.get(this.prismFormControl).setValue(defaultValue);
            this.setValueWithFormat(this.prismFormControl);
        }
        return this.i18n.replaceFromDotToComma(defaultValue);
    }

    getLabel(option: any): Observable<string> {
        return this.catalog.getFeatureTranslation(option[this.getKey(option)].templateID);
    }

    isVitaDt(option): boolean {
        return (this.getKey(option).toLowerCase() === "vita-dt");
    }

    formatFeaturesValue(feature: RangeFeature) {
        let newValue = this.i18n.formatIfNumber(this.form.get(feature.name).value, this.getDecimalFormat(feature.name));
        if(newValue)
            this.setValueToForm(this.form, feature.name, newValue);
    }

    getDecimalFormat(name: string): number {
        let featureDecimalFormat = this.decimalFormats.find(feature => feature.featureName === name);
        if(featureDecimalFormat) {
            return featureDecimalFormat.decimalFormat;
        }
    }

    onBlurMethod(feature: RangeFeature){
        this.formatFeaturesValue(feature);
    }

    private setValueToForm(form: FormGroup, key: string, value: any): void {
        form.get(key).setValue(this.replaceFromDotToComma(value.toString().trim()));
    }

    private replaceFromDotToComma(value: string): string {
        return value.replace(/\./g, ',');
    }

    setValueWithFormat(featureName: string) {
        if(this.formResponse.controls[featureName] && this.formResponse.controls[featureName].value) {
            this.formResponse.controls[featureName].setValue(
                this.i18n.replaceFromDotToComma(
                    this.i18n.formatIfNumber(this.formResponse.controls[featureName].value, this.globalStorageService.decimalFormats.find(feature => feature.featureName === featureName)?.decimalFormat)
                )
            );
        }
    }
}

const SPHERE = new RangeFeature("Sphere", false, 0, 0, 0);
const RADIUS_BASE_CURVE = new RangeFeature("RadiusBasecurve", false, 0, 0, 0);
const DIAMETER = new RangeFeature("Diameter", false, 0, 0, 0);
const RADIUS_BASE_CURVE_2 = new RangeFeature("RadiusBaseCurve2", false, 0, 0, 0);
const ECCENTRICITY = new RangeFeature("Excentricity", false, 0, 0, 0);
const DIOPTRE_STEEP = new RangeFeature("DioptreSteep", false, 0, 0, 0);
const CYLINDER = new RangeFeature("Cylinder", false, 0, 0, 0);
const AXIS_CYLINDER = new RangeFeature("AxisCylinder", false, 0, 0, 0);
const BACK_OPTIC_DIAMETER = new RangeFeature("BackOpticDiameter", false, 0, 0, 0);
const FLATTENING_PROFILE = new RangeFeature("FlatteningProfile", false, 0, 0, 0);
